import { createBrowserRouter, Navigate } from 'react-router-dom'
import type { User } from '@/api/types'
import { AuthenticatedRoutes } from './AuthenticatedRoutes'
import { UnauthenticatedRoutes } from './UnauthenticatedRoutes'

/**
 * Builds the router for the current auth state. A signed-in user gets the
 * authenticated routes, everyone else gets the public ones. Any unknown path
 * redirects home, where the right page is then shown for the state.
 */
export function getRouter(user: User | null) {
  const routes = user ? AuthenticatedRoutes : UnauthenticatedRoutes

  return createBrowserRouter([
    ...routes,
    {
      path: '*',
      element: (
        <Navigate
          to="/"
          replace
        />
      )
    }
  ])
}
